/*
 * IRIS Interactive
 *
 * NOTICE OF LICENSE
 *
 * This source file is no subject to a specific license
 * but it belongs to the company IRIS Interactive.
 * You can contact IRIS Interactive at the following
 * address: contact@iris-interactive.fr
 *
 * @author      Lucas ROCHE
 * @date        27/02/2020 11:10
 * @copyright   Copyright (c) 2002-2020 IRIS Interactive, Inc. (http://www.iris-interactive.fr)
 */

export default class Form {

    constructor()
    {
        Form.customizeInput()
        Form.customizeSelect()
        Form.resetEngine()
    }

    static customizeInput()
    {
        let form_items = $( '.wpcf7 [type="checkbox"], .wpcf7 [type="radio"]' )

        $( form_items ).each( function ( i, elm ) {
            let id         = $( elm ).attr( 'name' ) + '-' + i;
            let label_text = $( elm ).siblings( '.wpcf7-list-item-label' ).text();
            let label      = '<label for="' + id + '">' + label_text + '</label>';

            $( elm ).siblings( '.wpcf7-list-item-label' ).remove();
            $( elm ).parent().append( label );
            $( elm ).attr( 'id', id );
        } )
    }
    
    static customizeSelect()
    {
        $( 'select' ).parent().not( '.formSelect' ).children( 'select' ).wrap( '<div class="formSelect"></div>' );
    }

    static resetEngine() {
        const trigger = '[data-trigger="reset-engine"]';
        $(trigger).on('click', function(e) {
            e.preventDefault();
            window.location.href = window.location.protocol + '//' + window.location.host + window.location.pathname
        })
    }
}